/**
 * Production
 */
export const stripe_public_key =
  "pk_live_51NkSO9E6jR5FXDfMOwtpQXwY7nLCILhITsTxUQereaZv08xNg3VIDDmTnvJ17tj3f1pphbWZpRHFvNUhAtuez4DR005Z0ecTlC";

/**
 * Test
 *
 * export const stripe_public_key =
 *   "pk_test_51Rwpd8CsWJXl50VpIVRFDr2WxcLqdfsEFmktR0pnJOWxfQTENc6UZ74VXSKgnUbZMjoJcbARSD7chUrZKAsjvGxw00XdMPqrtP";
 */
